import React from "react";
import { Chip } from "@mui/material";

const PRIORIDAD_CONFIG = {
    BAJA: { label: "Baja", color: "#e3f2fd", text: "#1565c0" },
    MEDIA: { label: "Media", color: "#fff8e1", text: "#f57f17" },
    ALTA: { label: "Alta", color: "#fff3e0", text: "#e65100" },
    CRITICA: { label: "Crítica", color: "#fce4ec", text: "#b71c1c" },
};

/**
 * AuditPrioridadChip
 * Props:
 *   prioridad {string} — "BAJA" | "MEDIA" | "ALTA" | "CRITICA"
 *   size      {string} — "small" | "medium"
 */
export default function AuditPrioridadChip({ prioridad, size = "small" }) {
    const cfg = PRIORIDAD_CONFIG[prioridad] || PRIORIDAD_CONFIG.MEDIA;

    return (
        <Chip
            label={cfg.label}
            size={size}
            sx={{
                backgroundColor: cfg.color,
                color: cfg.text,
                fontWeight: 700,
                fontSize: size === "small" ? "0.72rem" : "0.8rem",
                border: `1px solid ${cfg.text}30`,
                "& .MuiChip-label": { px: 1.2 },
            }}
        />
    );
}
